import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';

import {
  Typography, Paper, IconButton, CircularProgress, Container,
} from '@mui/material';

import {
  Appbar,
} from '../Login/styles';
import QuicksightPermissionsCard from "./QuicksightPermissionsCard/QuicksightPermissionsCard";
import LogsCard from "./LogsSuperadmin/LogsSuperadminCard";
import EmailLogsCard from "./EmailLogsSuperadmin/EmailLogsSuperadminCard";
import { ArrowBack } from "@mui/icons-material";
import TableTitle from "../../UI/MaterialTableOverrides/TableTitle";
import Table from "@mui/material/Table";
import EnhancedTableHead from "../../UI/MaterialTableOverrides/EnhancedTableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import Avatar from "@mui/material/Avatar";
import moment from "moment-timezone";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TablePaginationActionsWrapped from "../../UI/MaterialTableOverrides/TablePaginationActions";

export default function Tenants(props) {
  const dispatch = useDispatch();
  let textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [limit, setLimit] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  const fetchTenants = useCallback(
    () => dispatch(actions.fetchTenants(page, limit, searchText, order, orderBy)),
    [page, limit, searchText, order, orderBy]
  );

  const tenants = useSelector(state => state.tenants.tenants);
  const loading = useSelector(state => state.tenants.loading);

  const headRows = [
    { id: "name", numeric: false, disablePadding: false, label: 'Nome' },
    { id: "blocked", numeric: false, disablePadding: false, label: 'Status' },
    { id: "createdAt", numeric: false, disablePadding: false, label: 'Criado em' },
  ];

  useEffect(() => {
    fetchTenants(page, limit, searchText, order, orderBy);
    setAlreadySerched(true);
  }, [page, limit, order, orderBy, searchText]);

  useEffect(() => {
    localStorage.removeItem('selectedTenant');
  }, []);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
  };

  const handleChangeRowsPerPage = e => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  const handleTenantClick = (id) => {
    props.history.push(`/tenant/${id}`);
  }

  const handleAddClick = () => {
    props.history.push(`/tenant/new`);
  }

  const handleQuicksightPermissoesClick = () => {
    props.history.push(`/tenant/quicksight`);
  }

  const handleLogsClick = () => {
    props.history.push(`/tenant/logs`);
  }

  const handleEmailLogsClick = () => {
    props.history.push(`/tenant/emaillogs`);
  }

  return <>
    <Appbar />
    <div style={{ margin: 30 }}>
      <IconButton
        style={styles.actionButton}
        aria-label="back"
        onClick={() => props.history.goBack()}
        size="large">
        <ArrowBack />
      </IconButton>
    </div>
    <div style={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "2.1875rem",
          opacity: loading ? 0.3 : 1
        }}
      >
        <QuicksightPermissionsCard
          click={() => handleQuicksightPermissoesClick()}
        />
        <LogsCard click={() => handleLogsClick()} />
        <EmailLogsCard click={() => handleEmailLogsClick()} />
      </div>
      <Container style={{ marginTop: "20px" }}>
        <Paper>
          <TableTitle
            title="Tenants"
            placeholder="Pesquisar"
            inputRef={textInput}
            value={searchText}
            onChange={event => {
              setPage(1);
              setSearchText(event.target.value);
            }}
            addRow={handleAddClick}
          />
          <Table style={styles.table}>
            <tbody>
              <tr>
                <td>
                  {loading && (
                    <div style={styles.spinner}>
                      <CircularProgress />
                    </div>
                  )}
                  {tenants.rows.length === 0 && (
                    <div style={styles.noResults}>
                      {!loading && (
                        <Typography style={styles.spinner}>
                          Nenhum resultado encontrado
                        </Typography>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
            <EnhancedTableHead
              style={{ opacity: loading ? 0.3 : 1 }}
              headRows={headRows}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={tenants.count ? tenants.count : 0}
            />
            <TableBody style={{ opacity: loading ? 0.3 : 1 }}>
              {tenants.rows &&
                tenants.rows.map((tenant, index) => {
                  return (
                    <TableRow
                      style={styles.tableRow}
                      key={tenant._id}
                      hover
                      onClick={() => handleTenantClick(tenant._id)}
                    >
                      <TableCell style={styles.cell}>
                        <div style={styles.cellPhotoContainer}>
                          {tenant.photo ? (
                            <Avatar
                              src={tenant.photo.url}
                              style={{
                                ...styles.avatar
                              }}
                            />
                          ) : (
                            <Avatar
                              style={{
                                ...styles.avatarSmallText
                              }}
                            >
                              FOTO
                            </Avatar>
                          )}
                          <div style={styles.tenantName}>
                            <div>{tenant.name}</div>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell style={styles.cell}>
                        {tenant.blocked ? "Bloqueado" : "Ativo"}
                      </TableCell>
                      <TableCell style={styles.cell}>
                        {moment(tenant.createdAt).format("DD/MM/YYYY")}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
            <TableFooter style={{ opacity: loading ? 0.3 : 1 }}>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  count={tenants.count}
                  rowsPerPage={parseInt(limit)}
                  page={page - 1}
                  SelectProps={{
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Paper>
      </Container>
    </div>
  </>;
}

const styles = {
  container: {
    margin: '0 auto',
    width: '1366px',
  },
  spinner: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },
  actionButton: {
    marginBottom: 2,
  },
  table: {
    position: 'relative',
    marginBottom: 50,
  },
  tableRow: {
    cursor: 'pointer'
  },
  noResults: {
    height: '100px',
  },
  avatar: {
    width: '2.75rem',
    height: '2.75rem',
    marginLeft: '0.25rem',
  },
  avatarSmallText: {
    fontSize: '0.75rem',
    width: '2.75rem',
    height: '2.75rem',
    marginLeft: '0.25rem',
  },
  cell: {
    fontSize: '0.775rem',
    padding: '0.25rem',
  },
  cellPhotoContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: '0.5rem',
  },
  tenantName: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '0.75rem',
  }
}
